import { render, staticRenderFns } from "./APP_TS.vue?vue&type=template&id=0a3a58e9&scoped=true&"
import script from "./APP_TS.vue?vue&type=script&lang=js&"
export * from "./APP_TS.vue?vue&type=script&lang=js&"
import style0 from "./APP_TS.vue?vue&type=style&index=0&id=0a3a58e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a58e9",
  null
  
)

component.options.__file = "APP_TS.vue"
export default component.exports